import { TextField } from '@material-ui/core';

const SmileInput = ({
  type,
  label,
  value,
  required,
  onChange,
  showError,
  disabled,
}) => {
  return (
    <TextField
      disabled={disabled}
      id={label}
      key={type}
      type={type}
      label={label}
      required={required}
      placeholder=""
      value={value ? value : ''}
      onChange={onChange}
      variant="outlined"
      InputProps={{
        style: {
          color: value ? 'inherit' : 'transparent',
        },
      }}
      onFocus={(e) => {
        e.target.style.color = 'inherit';
      }}
      onBlur={(e) => {
        if (!value) e.target.style.color = 'transparent';
      }}
      size={label?.length > 30 ? 'medium' : 'small'}
      inputProps={{ 'data-testid': `form${type}` }}
      error={showError}
      fullWidth
    />
  );
};

export default SmileInput;
